module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-16x16-22a4a78d269572480e3d48b7948a493b.png";